<div *ngIf="!showGuideList" class="resource-container">
  <div class="resource-center">
    <atlas-icon class="dsp-resource-close-icon" [icon]="'remove'" [collection]="'user-interface-solid'"
      [size]="'medium'" (click)="closeHelp()"></atlas-icon>

    <h3 class="resource-head">Resource Center</h3>
    <hr class="resource-center-hr">
  </div>
  <div class="resource-center-options">
    <div class="resource-guide-list">
      <atlas-icon class="dsp-resource-guide-icon" [icon]="'chevron-right'" [size]="'large'"
        (click)="showGuideListOptions()" [collection]="'arrows'">
      </atlas-icon>
      <h4 class="guide-list">Guide List</h4>
      <atlas-label class="typographyStyles-body-small">PRODUCT HELP</atlas-label>
      <hr class="resource-center-hr">
    </div>
    <div class="resource-submit-request">
      <h4 class="request-submit" (click)="openRequestModal()">Submit a Request</h4>
      <hr class="resource-center-hr">
    </div>
  </div>
</div>

<div *ngIf="showGuideList" class="resource-container">
  <div class="resource-center">
    <atlas-icon class="dsp-resource-close-icon" [icon]="'remove'" [collection]="'user-interface-solid'"
      [size]="'medium'" (click)="closeHelp()">
    </atlas-icon>


    <h3 class="resource-head">Guide List</h3>
    <atlas-icon class="dsp-resource-guide-list-icon" [icon]="'chevron-left'" [collection]="'arrows'" [size]="'large'"
      (click)="hideGuideListOptions()">
    </atlas-icon>
    <hr class="resource-center-hr">
  </div>

  <div class="resource-center-options">
    <div class="resource-homepage-walk">
      <h4 id="homepage-walk" style="cursor: pointer;">Homepage walk through</h4>
    </div>
  </div>
</div>

<dsp-resource-request-modal></dsp-resource-request-modal>